import { render, staticRenderFns } from "./FleetDetail.vue?vue&type=template&id=6080d3a5&"
import script from "./FleetDetail.vue?vue&type=script&lang=js&"
export * from "./FleetDetail.vue?vue&type=script&lang=js&"
import style0 from "./FleetDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports